import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import dayjs from "dayjs";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBan,
  faCheckCircle,
  faCircleNotch,
  faDice,
  faExternalLink,
  faPlus,
  faSignOut,
  faSync,
  faTimesCircle,
  faChevronLeft,
  faChevronDoubleLeft,
  faChevronRight,
  faChevronDoubleRight,
  faArrowDown,
  faArrowUp,
  faTrashAlt,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faExternalLinkAlt,
  faArrowLeft,
  faBoxes,
  faBuilding,
  faChartLine,
  faFolders,
  faHome,
  faNewspaper,
  faPennant,
  faShieldAlt,
  faSpade,
  faUserTag,
  faFilter,
  faArrowToBottom,
  faArrowToTop,
  faMoneyBill,
  faMoneyCheckAlt,
  faClipboard,
  faFileChartLine,
  faHandshake,
  faCalendar,
  faFileExport,
  faKey,
  faMoneyCheckEdit,
  faCheck,
  faMobile,
  faTrophyAlt,
  faFileAlt,
  faUserPlus,
  faUniversity,
  faCoins,
  faUser,
  faUsers,
  faMoneyBillWave,
  faStar,
  faCreditCard,
  faPresentation,
  faUserFriends,
  faIdCardAlt,
  faChartLineDown,
  faGamepad,
  faHistory,
  faFileInvoiceDollar,
  faPiggyBank,
  faWallet,
  faTachometerAlt,
  faMedal,
  faWrench,
  faGifts,
  faBoxesAlt,
  faPersonCarry,
  faImages,
  faTrash,
  faSignature,
  faSlidersHSquare,
  faBadgeCheck,
  faEraser,
  faUserSlash,
  faCopy,
  faTicketAlt,
    faSort,
    faSortUp,
    faSortDown,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/assets/app.scss";
import jwt_decode from "jwt-decode";
import * as publicIp from "public-ip";
import VCalendar from "v-calendar";
import { createI18n } from "vue-i18n";
import { messages } from "@/i18n/index";
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import * as crypto from "crypto"
import fingerPrint from '@fingerprintjs/fingerprintjs'

const icons = [
  faExternalLinkAlt,
  faBan,
  faArrowLeft,
  faArrowUp,
  faArrowDown,
  faUniversity,
  faUser,
  faStar,
  faCreditCard,
  faPresentation,
  faUserFriends,
  faIdCardAlt,
  faMoneyBillWave,
  faChartLineDown,
  faDice,
  faUsers,
  faExternalLink,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faCircleNotch,
  faSync,
  faCoins,
  faSignOut,
  faChevronLeft,
  faChevronDoubleLeft,
  faChevronRight,
  faChevronDoubleRight,
  faUserPlus,
  faHome,
  faChartLine,
  faBuilding,
  faSpade,
  faBoxes,
  faNewspaper,
  faPennant,
  faUserTag,
  faShieldAlt,
  faFolders,
  faFilter,
  faArrowToBottom,
  faArrowToTop,
  faMoneyCheckAlt,
  faMoneyBill,
  faClipboard,
  faFileChartLine,
  faHandshake,
  faCalendar,
  faFileExport,
  faKey,
  faMoneyCheckEdit,
  faCheck,
  faMobile,
  faTrophyAlt,
  faFileAlt,
  faGamepad,
  faHistory,
  faFileInvoiceDollar,
  faPiggyBank,
  faWallet,
  faTachometerAlt,
  faMedal,
  faWrench,
  faGifts,
  faBoxesAlt,
  faPersonCarry,
  faImages,
  faTrash,
  faSignature,
  faSlidersHSquare,
  faBadgeCheck,
  faEraser,
  faUserSlash,
  faCopy,
  faTicketAlt,
    faSort,
    faSortUp,
    faSortDown,
] as any;

library.add(icons);

const now = dayjs();
const app = createApp(App);
const i18n = createI18n({
  locale: "th",
  messages,
  legacy: false
});
app.provide("$axios", axios);
app.provide("$t", i18n);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component('maz-phone-number-input', MazPhoneNumberInput)
app.use(VCalendar, {});
app.use(store);
app.use(router);
app.use(i18n);
app.mount("#app");


axios.interceptors.request.use(async(request) => {
  if (store.state.user.token) {
    request.headers["Authorization"] = `Bearer ${store.state.user.token}`;
    request.headers["x-cm-forwarded-for"] = store.state.user.ip;
  }

  if (store.state.selectedOperator) {
    request.headers["x-cm-operator-id"] = (
      store.state.selectedOperator as any
    ).operatorId;
  }
  const visitorId  = await fingerPrint.load()
    .then(fp => fp.get())
    .then(result => result.visitorId)
  if (visitorId) {
    request.headers["x-cm-client-id"] = visitorId;
  }
  if(request.url?.includes(`${process.env.VUE_APP_API_ENDPOINT}`)){
    const _path = request.url?.split(`${process.env.VUE_APP_API_ENDPOINT}`)[1]
    const path = _path?.split(`?`)[0]
    const ts = Math.round(Date.now() / 1000.);
    const e = Number(process.env.VUE_APP_SIGNATURE_EXPIRE)
    const signature = process.env.VUE_APP_SIGNATURE_KEY
    const hashmac = crypto.createHmac('sha256', `${signature}`).update(`${path}|${ts}|${e}`).digest('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
    request.params = {...request.params, st: hashmac, e, ts}
  }
  return request;
});

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    const originalRequest = err.config;
    if (
      // (err.response.status == 401 || err.response.status == 403) &&
      (err.response.status == 401) &&
      !originalRequest._retry
    ) {
      return publicIp.v4().then((ip) => {
        store.commit("updateIpAddress", ip);
        return axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/auth/refresh-token",
            {
              refreshToken: store.state.user.token,
            },
            {
              headers: { "x-cm-forwarded-for": ip },
            }
          )
          .then(({ data }) => {
            let decode: any = jwt_decode(data.token);
            let username = store.state.user.username;
            /// 1.send user id to gw-admin(gw-oper => gw-admin => gw-auth)
            /// 2.set permission to setUserToken
            store.commit("setUserToken", {
              token: data.token,
              userId: decode.userId,
              exp: decode.exp,
              username: username,
              permissions: data.permissions,
            });

            return axios.request(originalRequest);
          })
          .catch((err) => {
            store.commit("removeUserInfo");
            store.commit("removeOperators");
            router.push({ name: "Login" });
          });
      });
    }

    return Promise.reject(err);
  }
);

if (!store.state.user.token) {
  router.push({ name: "Login" });
}

if (dayjs(store.state.user.expires * 1000).isBefore(now)) {
  publicIp.v4().then((ip) => {
    store.commit("updateIpAddress", ip);
    return axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/auth/refresh-token",
        {
          refreshToken: store.state.user.token,
        },
        {
          headers: { "x-cm-forwarded-for": ip },
        }
      )
      .then(({ data }) => {
        let decode: any = jwt_decode(data.token);
        let username = store.state.user.username;

        return store.commit("setUserToken", {
          token: data.token,
          userId: decode.userId,
          exp: decode.exp,
          username: username,
          permissions: decode.permissions,
        });
      })
      .catch((err) => {
        store.commit("removeUserInfo");
        store.commit("removeOperators");
        router.push({ name: "Login" });
      });
  });
}
